import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AddContractComponent } from './contracts/add/add.component';
import { ReportingGuard } from 'src/app/guards/reporting.guard';
import { EditContractComponent } from './contracts/edit/edit.component';
import { ContractsComponent } from './contracts/contracts.component';
import { EditComponentBusinessuser } from './edit/edit.component';
import { AddComponentBusinessuser } from './add/add.component';
import { AddCustomerOverviewComponent } from './add-customer-overview/add-customer-overview.component';
import { DashboardComponent } from './dashboard.component';
import { DetailsComponent } from './details/details.component';
import { ContactComponent } from './contact/contact.component';
import { SyncCustomerComponent } from './sync-customer/sync-customer.component';
import { HouseholdComponent } from '../household/household.component';
import { HouseholdOverviewComponent } from './household-overview/household-overview.component';
import { HouseholdMoveComponent } from './household-move/household-move.component';
import { AppMaterialModule } from 'src/app/helpers/app-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from 'src/app/components/shared-components.module';
import { SharedPipesModule } from 'src/app/pipes/shared-pipes.module';
import { TranslateStateModule } from 'src/app/pipes/translate-state.module';
import { TruncateModule } from 'src/app/pipes/truncate.module';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'overviewCustomer',
    component: AddCustomerOverviewComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'overviewCustomer/add/:type',
    component: AddComponentBusinessuser,
    canActivate: [ReportingGuard]
  },
  {
    path: 'edit/:id',
    component: EditComponentBusinessuser,
    canActivate: [ReportingGuard]
  },
  {
    path: ':id/contracts',
    component: ContractsComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':id/contracts/edit/:cid',
    component: EditContractComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':id/contracts/add',
    component: AddContractComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'details/:id',
    component: DetailsComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'contact/:id',
    component: ContactComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'sync/:id',
    component: SyncCustomerComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'household/:id',
    component: HouseholdOverviewComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'household-move/:id',
    component: HouseholdMoveComponent,
    canActivate: [ReportingGuard]
  }
]


@NgModule({
  declarations: [  
    DashboardComponent,
    AddCustomerOverviewComponent,
    AddComponentBusinessuser,
    EditComponentBusinessuser,
    ContractsComponent,
    AddContractComponent,
    DetailsComponent,
    ContactComponent,
    SyncCustomerComponent,
    HouseholdOverviewComponent,
    HouseholdMoveComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedPipesModule,
    SharedComponentsModule,
    TranslateStateModule,
    TruncateModule
  ],
  exports: [RouterModule],
})
export class DashboardModule { }
